/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAccessTokenFromLocalStorage } from "../utilities/token-util";
export class BaseClient {
  public async transformOptions(options: RequestInit): Promise<RequestInit> {
    const token = localStorage.getItem("token");
    const headerData = token
      ? {
          ...options.headers,
          Authorization: "Bearer " + token,
        }
      : {
          ...options.headers,
        };
    return Object.assign({}, options, {
      headers: headerData,
    });
  }
}

export class DeviceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getDevices(): Promise<Devices[]> {
        let url_ = this.baseUrl + "/api/Device";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: Response): Promise<Devices[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Devices.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices[]>(<any>null);
    }

    getDevice(deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/GetById?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }

    getAllDevices(dateFrom: Date | null | undefined, dateTo: Date | null | undefined): Promise<DeviceDto[]> {
        let url_ = this.baseUrl + "/api/Device/GetAllDevices?";
        if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDevices(_response);
        });
    }

    protected processGetAllDevices(response: Response): Promise<DeviceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDto.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceDto[]>(<any>null);
    }

    getUserDevices(dateFrom: Date | null | undefined, dateTo: Date | null | undefined): Promise<DeviceDto[]> {
        let url_ = this.baseUrl + "/api/Device/GetUserDevices?";
        if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserDevices(_response);
        });
    }

    protected processGetUserDevices(response: Response): Promise<DeviceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDto.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceDto[]>(<any>null);
    }

    deleteUserDevice(deviceId: string | null | undefined, userId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/DeleteUserDevice?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserDevice(_response);
        });
    }

    protected processDeleteUserDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    addUserDevice(deviceId: string | null | undefined, userId: string | null | undefined): Promise<DeviceUser> {
        let url_ = this.baseUrl + "/api/Device/AddUserDevice?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserDevice(_response);
        });
    }

    protected processAddUserDevice(response: Response): Promise<DeviceUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceUser.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceUser>(<any>null);
    }

    downloadCsv(deviceIds: string[], dateFrom: Date | undefined, dateTo: Date | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Device/DownloadCsv?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceIds);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCsv(_response);
        });
    }

    protected processDownloadCsv(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    uploadCsv(deviceId: string | null | undefined, file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/UploadCsv?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadCsv(_response);
        });
    }

    protected processUploadCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateCalibrationFactor(calibratingFactor: number | undefined, deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/UpdateCalibrationFactor?";
        if (calibratingFactor === null)
            throw new Error("The parameter 'calibratingFactor' cannot be null.");
        else if (calibratingFactor !== undefined)
            url_ += "calibratingFactor=" + encodeURIComponent("" + calibratingFactor) + "&";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCalibrationFactor(_response);
        });
    }

    protected processUpdateCalibrationFactor(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }

    updateSpectralMeasurement(spectralMeasurement: number | undefined, deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/UpdateSpectralMeasurement?";
        if (spectralMeasurement === null)
            throw new Error("The parameter 'spectralMeasurement' cannot be null.");
        else if (spectralMeasurement !== undefined)
            url_ += "spectralMeasurement=" + encodeURIComponent("" + spectralMeasurement) + "&";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSpectralMeasurement(_response);
        });
    }

    protected processUpdateSpectralMeasurement(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }

    updateLabMeasurement(labMeasurement: number | undefined, deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/UpdateLabMeasurement?";
        if (labMeasurement === null)
            throw new Error("The parameter 'labMeasurement' cannot be null.");
        else if (labMeasurement !== undefined)
            url_ += "labMeasurement=" + encodeURIComponent("" + labMeasurement) + "&";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLabMeasurement(_response);
        });
    }

    protected processUpdateLabMeasurement(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }

    calibrateDevice(deviceId: string | null | undefined, timeOfMeasurement: Date | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/CalibrateDevice?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (timeOfMeasurement === null)
            throw new Error("The parameter 'timeOfMeasurement' cannot be null.");
        else if (timeOfMeasurement !== undefined)
            url_ += "timeOfMeasurement=" + encodeURIComponent(timeOfMeasurement ? "" + timeOfMeasurement.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalibrateDevice(_response);
        });
    }

    protected processCalibrateDevice(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }

    updateSpectralMeasurementDateTime(measureDateTime: Date | undefined, deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/UpdateSpectralMeasurementDateTime?";
        if (measureDateTime === null)
            throw new Error("The parameter 'measureDateTime' cannot be null.");
        else if (measureDateTime !== undefined)
            url_ += "measureDateTime=" + encodeURIComponent(measureDateTime ? "" + measureDateTime.toJSON() : "") + "&";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSpectralMeasurementDateTime(_response);
        });
    }

    protected processUpdateSpectralMeasurementDateTime(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }

    updateStationId(stationId: string | null | undefined, deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/Device/UpdateStationId?";
        if (stationId !== undefined)
            url_ += "stationId=" + encodeURIComponent("" + stationId) + "&";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStationId(_response);
        });
    }

    protected processUpdateStationId(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }
}

export class DmiApiClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getDmiApiPrecipitation(stationId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined): Promise<ObservationV2[]> {
        let url_ = this.baseUrl + "/api/DmiApi?";
        if (stationId !== undefined)
            url_ += "stationId=" + encodeURIComponent("" + stationId) + "&";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDmiApiPrecipitation(_response);
        });
    }

    protected processGetDmiApiPrecipitation(response: Response): Promise<ObservationV2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationV2.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObservationV2[]>(<any>null);
    }
}

export class NotificationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getUserNotifications(): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/Notification/GetUserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserNotifications(_response);
        });
    }

    protected processGetUserNotifications(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(<any>null);
    }
}

export class NotificationSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getUserSettings(): Promise<NotificationSettings[]> {
        let url_ = this.baseUrl + "/api/NotificationSettings/GetUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSettings(_response);
        });
    }

    protected processGetUserSettings(response: Response): Promise<NotificationSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSettings.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSettings[]>(<any>null);
    }

    getSettingsForSingleDevice(deviceId: string | null | undefined): Promise<NotificationSettings[]> {
        let url_ = this.baseUrl + "/api/NotificationSettings/GetSettingsForSingleDevice?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSettingsForSingleDevice(_response);
        });
    }

    protected processGetSettingsForSingleDevice(response: Response): Promise<NotificationSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSettings.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSettings[]>(<any>null);
    }

    addOrUpdateLimit(settings: NotificationSettings): Promise<NotificationSettings> {
        let url_ = this.baseUrl + "/api/NotificationSettings/AddOrUpdateLimit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrUpdateLimit(_response);
        });
    }

    protected processAddOrUpdateLimit(response: Response): Promise<NotificationSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSettings>(<any>null);
    }

    addOrUpdateEmailSetting(settings: NotificationSettings): Promise<NotificationSettings> {
        let url_ = this.baseUrl + "/api/NotificationSettings/AddOrUpdateEmailSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrUpdateEmailSetting(_response);
        });
    }

    protected processAddOrUpdateEmailSetting(response: Response): Promise<NotificationSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSettings>(<any>null);
    }

    addOrUpdateShowWebNotificationSetting(settings: NotificationSettings): Promise<NotificationSettings> {
        let url_ = this.baseUrl + "/api/NotificationSettings/AddOrUpdateShowWebNotificationSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrUpdateShowWebNotificationSetting(_response);
        });
    }

    protected processAddOrUpdateShowWebNotificationSetting(response: Response): Promise<NotificationSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSettings>(<any>null);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getUsers(): Promise<User[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }
}

export class CloudServiceDeviceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getAllDevices(): Promise<Devices[]> {
        let url_ = this.baseUrl + "/api/CloudServiceDevice/GetAllDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDevices(_response);
        });
    }

    protected processGetAllDevices(response: Response): Promise<Devices[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Devices.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices[]>(<any>null);
    }
}

export class ModelExposerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getNitrateLogTransEntity(): Promise<NitrateLogTransEntity> {
        let url_ = this.baseUrl + "/api/ModelExposer/NitrateLogTransEntity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNitrateLogTransEntity(_response);
        });
    }

    protected processGetNitrateLogTransEntity(response: Response): Promise<NitrateLogTransEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NitrateLogTransEntity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NitrateLogTransEntity>(<any>null);
    }
}

export class NotificationHubDeviceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    getById(deviceId: string | null | undefined): Promise<Devices> {
        let url_ = this.baseUrl + "/api/NotificationHubDevice/GetById?";
        if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Devices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Devices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Devices>(<any>null);
    }
}

export class NotificationHubNotificationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    post(entity: Notification): Promise<Notification> {
        let url_ = this.baseUrl + "/api/NotificationHubNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entity);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Notification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(<any>null);
    }

    closeNotification(notificationId: number | undefined, reason: ClosedReason | undefined, closedTime: Date | undefined): Promise<Notification> {
        let url_ = this.baseUrl + "/api/NotificationHubNotification?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (closedTime === null)
            throw new Error("The parameter 'closedTime' cannot be null.");
        else if (closedTime !== undefined)
            url_ += "closedTime=" + encodeURIComponent(closedTime ? "" + closedTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCloseNotification(_response);
        });
    }

    protected processCloseNotification(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Notification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(<any>null);
    }

    getLatestNotifications(deviceIds: string[] | null | undefined, types: NotificationType[] | null | undefined): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/NotificationHubNotification/GetLatestNotifications?";
        if (deviceIds !== undefined)
            deviceIds && deviceIds.forEach(item => { url_ += "deviceIds=" + encodeURIComponent("" + item) + "&"; });
        if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestNotifications(_response);
        });
    }

    protected processGetLatestNotifications(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(<any>null);
    }
}

export class NotificationHubSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "http://localhost:64612";
    }

    get(): Promise<NotificationSettings[]> {
        let url_ = this.baseUrl + "/api/NotificationHubSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationSettings.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationSettings[]>(<any>null);
    }
}

export class ModelBase implements IModelBase {
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    isDeleted!: boolean;

    constructor(data?: IModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new ModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }
}

export interface IModelBase {
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    isDeleted: boolean;
}

export class Devices extends ModelBase implements IDevices {
    stationId?: string | undefined;
    deviceId?: string | undefined;
    dataTypeName?: string | undefined;
    calibrationFactor?: number | undefined;
    labMeasurement?: number | undefined;
    spectralMeasurement?: number | undefined;
    spectralMeasurementDateTime?: Date | undefined;
    lastChanged?: Date | undefined;
    dataTypeNameNavigation?: DataTypes | undefined;
    deviceServices?: DeviceServices[] | undefined;
    deviceUsers?: DeviceUser[] | undefined;
    notifications?: Notification[] | undefined;
    notificationSettings?: NotificationSettings[] | undefined;

    constructor(data?: IDevices) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stationId = _data["stationId"];
            this.deviceId = _data["deviceId"];
            this.dataTypeName = _data["dataTypeName"];
            this.calibrationFactor = _data["calibrationFactor"];
            this.labMeasurement = _data["labMeasurement"];
            this.spectralMeasurement = _data["spectralMeasurement"];
            this.spectralMeasurementDateTime = _data["spectralMeasurementDateTime"] ? new Date(_data["spectralMeasurementDateTime"].toString()) : <any>undefined;
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
            this.dataTypeNameNavigation = _data["dataTypeNameNavigation"] ? DataTypes.fromJS(_data["dataTypeNameNavigation"]) : <any>undefined;
            if (Array.isArray(_data["deviceServices"])) {
                this.deviceServices = [] as any;
                for (let item of _data["deviceServices"])
                    this.deviceServices!.push(DeviceServices.fromJS(item));
            }
            if (Array.isArray(_data["deviceUsers"])) {
                this.deviceUsers = [] as any;
                for (let item of _data["deviceUsers"])
                    this.deviceUsers!.push(DeviceUser.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(Notification.fromJS(item));
            }
            if (Array.isArray(_data["notificationSettings"])) {
                this.notificationSettings = [] as any;
                for (let item of _data["notificationSettings"])
                    this.notificationSettings!.push(NotificationSettings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Devices {
        data = typeof data === 'object' ? data : {};
        let result = new Devices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stationId"] = this.stationId;
        data["deviceId"] = this.deviceId;
        data["dataTypeName"] = this.dataTypeName;
        data["calibrationFactor"] = this.calibrationFactor;
        data["labMeasurement"] = this.labMeasurement;
        data["spectralMeasurement"] = this.spectralMeasurement;
        data["spectralMeasurementDateTime"] = this.spectralMeasurementDateTime ? this.spectralMeasurementDateTime.toISOString() : <any>undefined;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        data["dataTypeNameNavigation"] = this.dataTypeNameNavigation ? this.dataTypeNameNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceServices)) {
            data["deviceServices"] = [];
            for (let item of this.deviceServices)
                data["deviceServices"].push(item.toJSON());
        }
        if (Array.isArray(this.deviceUsers)) {
            data["deviceUsers"] = [];
            for (let item of this.deviceUsers)
                data["deviceUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationSettings)) {
            data["notificationSettings"] = [];
            for (let item of this.notificationSettings)
                data["notificationSettings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IDevices extends IModelBase {
    stationId?: string | undefined;
    deviceId?: string | undefined;
    dataTypeName?: string | undefined;
    calibrationFactor?: number | undefined;
    labMeasurement?: number | undefined;
    spectralMeasurement?: number | undefined;
    spectralMeasurementDateTime?: Date | undefined;
    lastChanged?: Date | undefined;
    dataTypeNameNavigation?: DataTypes | undefined;
    deviceServices?: DeviceServices[] | undefined;
    deviceUsers?: DeviceUser[] | undefined;
    notifications?: Notification[] | undefined;
    notificationSettings?: NotificationSettings[] | undefined;
}

export class DataTypes extends ModelBase implements IDataTypes {
    dataTypeName?: string | undefined;
    devices?: Devices[] | undefined;

    constructor(data?: IDataTypes) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dataTypeName = _data["dataTypeName"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(Devices.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataTypes {
        data = typeof data === 'object' ? data : {};
        let result = new DataTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTypeName"] = this.dataTypeName;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IDataTypes extends IModelBase {
    dataTypeName?: string | undefined;
    devices?: Devices[] | undefined;
}

export class DeviceServices extends ModelBase implements IDeviceServices {
    deviceId?: string | undefined;
    serviceName?: string | undefined;
    device?: Devices | undefined;
    serviceNameNavigation?: Services | undefined;
    geokonAdditionalProperties?: GeokonAdditionalProperties | undefined;
    geusAdditionalProperties?: GeusAdditionalProperties | undefined;

    constructor(data?: IDeviceServices) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.serviceName = _data["serviceName"];
            this.device = _data["device"] ? Devices.fromJS(_data["device"]) : <any>undefined;
            this.serviceNameNavigation = _data["serviceNameNavigation"] ? Services.fromJS(_data["serviceNameNavigation"]) : <any>undefined;
            this.geokonAdditionalProperties = _data["geokonAdditionalProperties"] ? GeokonAdditionalProperties.fromJS(_data["geokonAdditionalProperties"]) : <any>undefined;
            this.geusAdditionalProperties = _data["geusAdditionalProperties"] ? GeusAdditionalProperties.fromJS(_data["geusAdditionalProperties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceServices {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["serviceName"] = this.serviceName;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["serviceNameNavigation"] = this.serviceNameNavigation ? this.serviceNameNavigation.toJSON() : <any>undefined;
        data["geokonAdditionalProperties"] = this.geokonAdditionalProperties ? this.geokonAdditionalProperties.toJSON() : <any>undefined;
        data["geusAdditionalProperties"] = this.geusAdditionalProperties ? this.geusAdditionalProperties.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IDeviceServices extends IModelBase {
    deviceId?: string | undefined;
    serviceName?: string | undefined;
    device?: Devices | undefined;
    serviceNameNavigation?: Services | undefined;
    geokonAdditionalProperties?: GeokonAdditionalProperties | undefined;
    geusAdditionalProperties?: GeusAdditionalProperties | undefined;
}

export class Services extends ModelBase implements IServices {
    serviceName?: string | undefined;
    deviceServices?: DeviceServices[] | undefined;

    constructor(data?: IServices) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serviceName = _data["serviceName"];
            if (Array.isArray(_data["deviceServices"])) {
                this.deviceServices = [] as any;
                for (let item of _data["deviceServices"])
                    this.deviceServices!.push(DeviceServices.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Services {
        data = typeof data === 'object' ? data : {};
        let result = new Services();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        if (Array.isArray(this.deviceServices)) {
            data["deviceServices"] = [];
            for (let item of this.deviceServices)
                data["deviceServices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IServices extends IModelBase {
    serviceName?: string | undefined;
    deviceServices?: DeviceServices[] | undefined;
}

export class GeokonAdditionalProperties extends ModelBase implements IGeokonAdditionalProperties {
    deviceId?: string | undefined;
    serviceName?: string | undefined;
    deviceKey?: string | undefined;
    deviceServices?: DeviceServices | undefined;

    constructor(data?: IGeokonAdditionalProperties) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.serviceName = _data["serviceName"];
            this.deviceKey = _data["deviceKey"];
            this.deviceServices = _data["deviceServices"] ? DeviceServices.fromJS(_data["deviceServices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeokonAdditionalProperties {
        data = typeof data === 'object' ? data : {};
        let result = new GeokonAdditionalProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["serviceName"] = this.serviceName;
        data["deviceKey"] = this.deviceKey;
        data["deviceServices"] = this.deviceServices ? this.deviceServices.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IGeokonAdditionalProperties extends IModelBase {
    deviceId?: string | undefined;
    serviceName?: string | undefined;
    deviceKey?: string | undefined;
    deviceServices?: DeviceServices | undefined;
}

export class GeusAdditionalProperties extends ModelBase implements IGeusAdditionalProperties {
    deviceId?: string | undefined;
    serviceName?: string | undefined;
    latitude!: number;
    longitude!: number;
    deviceServices?: DeviceServices | undefined;

    constructor(data?: IGeusAdditionalProperties) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.serviceName = _data["serviceName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.deviceServices = _data["deviceServices"] ? DeviceServices.fromJS(_data["deviceServices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeusAdditionalProperties {
        data = typeof data === 'object' ? data : {};
        let result = new GeusAdditionalProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["serviceName"] = this.serviceName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["deviceServices"] = this.deviceServices ? this.deviceServices.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IGeusAdditionalProperties extends IModelBase {
    deviceId?: string | undefined;
    serviceName?: string | undefined;
    latitude: number;
    longitude: number;
    deviceServices?: DeviceServices | undefined;
}

export class DeviceUser implements IDeviceUser {
    devices?: Devices | undefined;
    deviceId?: string | undefined;
    user?: User | undefined;
    userId?: string | undefined;

    constructor(data?: IDeviceUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.devices = _data["devices"] ? Devices.fromJS(_data["devices"]) : <any>undefined;
            this.deviceId = _data["deviceId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DeviceUser {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["devices"] = this.devices ? this.devices.toJSON() : <any>undefined;
        data["deviceId"] = this.deviceId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IDeviceUser {
    devices?: Devices | undefined;
    deviceId?: string | undefined;
    user?: User | undefined;
    userId?: string | undefined;
}

export class User extends ModelBase implements IUser {
    id?: string | undefined;
    email?: string | undefined;
    deviceUsers?: DeviceUser[] | undefined;
    notificationSettings?: NotificationSettings[] | undefined;
    notifications?: Notification[] | undefined;

    constructor(data?: IUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            if (Array.isArray(_data["deviceUsers"])) {
                this.deviceUsers = [] as any;
                for (let item of _data["deviceUsers"])
                    this.deviceUsers!.push(DeviceUser.fromJS(item));
            }
            if (Array.isArray(_data["notificationSettings"])) {
                this.notificationSettings = [] as any;
                for (let item of _data["notificationSettings"])
                    this.notificationSettings!.push(NotificationSettings.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(Notification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        if (Array.isArray(this.deviceUsers)) {
            data["deviceUsers"] = [];
            for (let item of this.deviceUsers)
                data["deviceUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationSettings)) {
            data["notificationSettings"] = [];
            for (let item of this.notificationSettings)
                data["notificationSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IUser extends IModelBase {
    id?: string | undefined;
    email?: string | undefined;
    deviceUsers?: DeviceUser[] | undefined;
    notificationSettings?: NotificationSettings[] | undefined;
    notifications?: Notification[] | undefined;
}

export class ModelBaseId extends ModelBase implements IModelBaseId {
    id?: number | undefined;

    constructor(data?: IModelBaseId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModelBaseId {
        data = typeof data === 'object' ? data : {};
        let result = new ModelBaseId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data; 
    }
}

export interface IModelBaseId extends IModelBase {
    id?: number | undefined;
}

export class NotificationSettings extends ModelBaseId implements INotificationSettings {
    deviceId?: string | undefined;
    type!: NotificationType;
    limit?: number | undefined;
    emailUserWhenExceedingLimit!: boolean;
    showNotificationWeb!: boolean;
    device?: Devices | undefined;
    userId?: string | undefined;
    user?: User | undefined;

    constructor(data?: INotificationSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.type = _data["type"];
            this.limit = _data["limit"];
            this.emailUserWhenExceedingLimit = _data["emailUserWhenExceedingLimit"];
            this.showNotificationWeb = _data["showNotificationWeb"];
            this.device = _data["device"] ? Devices.fromJS(_data["device"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["type"] = this.type;
        data["limit"] = this.limit;
        data["emailUserWhenExceedingLimit"] = this.emailUserWhenExceedingLimit;
        data["showNotificationWeb"] = this.showNotificationWeb;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface INotificationSettings extends IModelBaseId {
    deviceId?: string | undefined;
    type: NotificationType;
    limit?: number | undefined;
    emailUserWhenExceedingLimit: boolean;
    showNotificationWeb: boolean;
    device?: Devices | undefined;
    userId?: string | undefined;
    user?: User | undefined;
}

export enum NotificationType {
    Nitrat = 0,
    Temperature = 1,
    LowBattery = 2,
    NitrateNitrogen = 3,
}

export class Notification extends ModelBaseId implements INotification {
    type!: NotificationType;
    payload!: number;
    timestamp!: Date;
    isOpen!: boolean;
    closedOn?: Date | undefined;
    closedReason?: ClosedReason | undefined;
    showOnWeb!: boolean;
    deviceId?: string | undefined;
    device?: Devices | undefined;
    userId?: string | undefined;
    user?: User | undefined;

    constructor(data?: INotification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.payload = _data["payload"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.isOpen = _data["isOpen"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.closedReason = _data["closedReason"];
            this.showOnWeb = _data["showOnWeb"];
            this.deviceId = _data["deviceId"];
            this.device = _data["device"] ? Devices.fromJS(_data["device"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["payload"] = this.payload;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["isOpen"] = this.isOpen;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["closedReason"] = this.closedReason;
        data["showOnWeb"] = this.showOnWeb;
        data["deviceId"] = this.deviceId;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface INotification extends IModelBaseId {
    type: NotificationType;
    payload: number;
    timestamp: Date;
    isOpen: boolean;
    closedOn?: Date | undefined;
    closedReason?: ClosedReason | undefined;
    showOnWeb: boolean;
    deviceId?: string | undefined;
    device?: Devices | undefined;
    userId?: string | undefined;
    user?: User | undefined;
}

export enum ClosedReason {
    SystemClosed = 0,
}

export class DeviceDto extends Devices implements IDeviceDto {
    data?: LogTransEntity[] | undefined;
    active!: boolean;
    displayName?: string | undefined;

    constructor(data?: IDeviceDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LogTransEntity.fromJS(item));
            }
            this.active = _data["active"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["active"] = this.active;
        data["displayName"] = this.displayName;
        super.toJSON(data);
        return data; 
    }
}

export interface IDeviceDto extends IDevices {
    data?: LogTransEntity[] | undefined;
    active: boolean;
    displayName?: string | undefined;
}

export class TableEntity implements ITableEntity {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp!: Date;
    eTag?: string | undefined;

    constructor(data?: ITableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.rowKey = _data["rowKey"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.eTag = _data["eTag"];
        }
    }

    static fromJS(data: any): TableEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TableEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["rowKey"] = this.rowKey;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["eTag"] = this.eTag;
        return data; 
    }
}

export interface ITableEntity {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp: Date;
    eTag?: string | undefined;
}

export class LogTransEntity extends TableEntity implements ILogTransEntity {
    measurementTime!: Date;
    powerSupplyVoltage!: number;
    internalBoardTemperature!: number;
    signalStrength!: number;
    minMaxEnabled!: boolean;
    checksum!: number;
    calibrationFactor?: number | undefined;
    correctedNitrateConcentration!: number;
    nitrateConcentrationOptical!: number;
    nitrateNitrogenConcentrationOptical!: number;
    nitrateConcentrationConductivity!: number;
    sensorTemperature!: number;

    constructor(data?: ILogTransEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.measurementTime = _data["measurementTime"] ? new Date(_data["measurementTime"].toString()) : <any>undefined;
            this.powerSupplyVoltage = _data["powerSupplyVoltage"];
            this.internalBoardTemperature = _data["internalBoardTemperature"];
            this.signalStrength = _data["signalStrength"];
            this.minMaxEnabled = _data["minMaxEnabled"];
            this.checksum = _data["checksum"];
            this.calibrationFactor = _data["calibrationFactor"];
            this.correctedNitrateConcentration = _data["correctedNitrateConcentration"];
            this.nitrateConcentrationOptical = _data["nitrateConcentrationOptical"];
            this.nitrateNitrogenConcentrationOptical = _data["nitrateNitrogenConcentrationOptical"];
            this.nitrateConcentrationConductivity = _data["nitrateConcentrationConductivity"];
            this.sensorTemperature = _data["sensorTemperature"];
        }
    }

    static fromJS(data: any): LogTransEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LogTransEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementTime"] = this.measurementTime ? this.measurementTime.toISOString() : <any>undefined;
        data["powerSupplyVoltage"] = this.powerSupplyVoltage;
        data["internalBoardTemperature"] = this.internalBoardTemperature;
        data["signalStrength"] = this.signalStrength;
        data["minMaxEnabled"] = this.minMaxEnabled;
        data["checksum"] = this.checksum;
        data["calibrationFactor"] = this.calibrationFactor;
        data["correctedNitrateConcentration"] = this.correctedNitrateConcentration;
        data["nitrateConcentrationOptical"] = this.nitrateConcentrationOptical;
        data["nitrateNitrogenConcentrationOptical"] = this.nitrateNitrogenConcentrationOptical;
        data["nitrateConcentrationConductivity"] = this.nitrateConcentrationConductivity;
        data["sensorTemperature"] = this.sensorTemperature;
        super.toJSON(data);
        return data; 
    }
}

export interface ILogTransEntity extends ITableEntity {
    measurementTime: Date;
    powerSupplyVoltage: number;
    internalBoardTemperature: number;
    signalStrength: number;
    minMaxEnabled: boolean;
    checksum: number;
    calibrationFactor?: number | undefined;
    correctedNitrateConcentration: number;
    nitrateConcentrationOptical: number;
    nitrateNitrogenConcentrationOptical: number;
    nitrateConcentrationConductivity: number;
    sensorTemperature: number;
}

export class ObservationV2 implements IObservationV2 {
    properties?: Property | undefined;

    constructor(data?: IObservationV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.properties = _data["properties"] ? Property.fromJS(_data["properties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ObservationV2 {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IObservationV2 {
    properties?: Property | undefined;
}

export class Property implements IProperty {
    value!: number;
    stationId?: string | undefined;
    observed!: Date;

    constructor(data?: IProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.stationId = _data["stationId"];
            this.observed = _data["observed"] ? new Date(_data["observed"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Property {
        data = typeof data === 'object' ? data : {};
        let result = new Property();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["stationId"] = this.stationId;
        data["observed"] = this.observed ? this.observed.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IProperty {
    value: number;
    stationId?: string | undefined;
    observed: Date;
}

export class NitrateLogTransEntity extends LogTransEntity implements INitrateLogTransEntity {
    correctedNitrateConcentration!: number;

    constructor(data?: INitrateLogTransEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.correctedNitrateConcentration = _data["correctedNitrateConcentration"];
        }
    }

    static fromJS(data: any): NitrateLogTransEntity {
        data = typeof data === 'object' ? data : {};
        let result = new NitrateLogTransEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correctedNitrateConcentration"] = this.correctedNitrateConcentration;
        super.toJSON(data);
        return data; 
    }
}

export interface INitrateLogTransEntity extends ILogTransEntity {
    correctedNitrateConcentration: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// This class is copied to api.ts when running codegen.